export const ORG_PERMITTED_ACCOUNTS_URL = 'frontend/organization/get-permitted-accounts';

export const ZD_SEND_MIGRATION_TASK_URL = 'zesty-disk-migration/send-migration-task';
export const ZD_CHECK_MIGRATION_STATUS_URL = 'zesty-disk-migration/retrieve-migration-task-status';
export const ZD_DELETE_MIGRATION_TASK_URL = 'zesty-disk/delete-migration-task';

export const ZD_HAS_MANAGED_DISKS_URL = 'zesty-disk/has-managed';
export const ZD_LOAD_MANAGED_DISKS_URL = 'zesty-disk/get-managed-disks-pagination';
export const ZD_GET_MANAGED_CAPACITY_URL = 'zesty-disk/get-managed-capacity';
export const ZD_GET_POLICIES_URL = 'zesty-disk/get-policies';
export const ZD_GET_ATTACHED_POLICIES_URL = 'zesty-disk/get-attached-policies';
export const ZD_ATTACH_POLICY_URL = 'zesty-disk/attach-policy';
export const ZD_DETACH_POLICY_URL = 'zesty-disk/delete-attached-policy';
export const ZD_SAVE_POLICY_URL = 'zesty-disk/save-policy';
export const ZD_SAVE_MANAGED_POLICY_URL = 'zesty-disk/save-zd-policy';
export const ZD_TOTAL_EBS_COST_URL = 'zesty-disk/total-ebs-cost';
export const ZD_POTENTIAL_SAVINGS_URL = 'zesty-disk/get-potential-savings';
export const ZD_LIVE_BILLING_URL = 'zesty-disk/zdisk-live-billing';
export const ZD_LOAD_METRICS_URL = 'zesty-disk/load-metrics';
export const ZD_LOAD_UNMANAGED_DISKS_URL = 'zesty-disk/load-unmanaged-disks';
export const ZD_GET_TAGS_URL = 'zesty-disk/get-unique-instances-tags';

export const ZD_FILE_SYSTEMS = 'zesty-disk/filesystems';
export const ZD_MF_CSV_PROCESS_STATE = `zesty-disk/check_managed_filesystems_export_process_state`;
export const ZD_MF_CSV_PROCESS_START = `zesty-disk/start_managed_filesystems_export_process`;
export const ZD_UNMANAGED_VOLUMES_CSV_PROCESS_START = 'zesty-disk/start_unmanaged_volumes_export_process';
export const ZD_UNMANAGED_VOLUMES_CSV_PROCESS_STATE = 'zesty-disk/check_unmanaged_volumes_export_process_state';
export const EBS_PREVIOUS_MTHLY_COST = 'zesty-disk/ebsCostOptimization';
export const SERVICE_BREAKDOWN = 'optimizationHub/api/v1/cur/servicesCostBreakdown';

export const CSV_ENDPOINTS = {
	MANAGED_FS: {
		STATE: ZD_MF_CSV_PROCESS_STATE,
		START: ZD_MF_CSV_PROCESS_START,
	},
	UNMANAGED_VOLUMES: {
		STATE: ZD_UNMANAGED_VOLUMES_CSV_PROCESS_STATE,
		START: ZD_UNMANAGED_VOLUMES_CSV_PROCESS_START,
	},
};
